<template>
    <div class="kb-menu">
        <div class="kb-header">
            <div class="kb-title">База знаний</div>
        </div>

        <div class="kb-content-root">
            <menu-tree-item
                v-for="item in items"
                :key="item.id"
                :item="item"
                :level="0"
                :hash="hash"
                :item-route-name="itemRouteName"
                @loadItems="handleLoadItems"
                @itemClick="handleItemClick"
            />
        </div>
    </div>

</template>

<script>
    import MenuTreeItem from './MenuTreeItem.vue';

    export default {
        name: 'MenuSection',
        components: { MenuTreeItem },
        props: {
            items: {
                type: Array,
                default: () => []
            },
            hash: {
                type: String,
                required: true
            },
            itemRouteName: {
                type: String,
                default: 'section-detail-item'
            }
        },
        emits: ['loadItems', 'itemClick'],
        methods: {
            handleLoadItems(data) {
                this.$emit('loadItems', data);
            },
            handleItemClick(item) {
                this.$emit('itemClick', item);
            }
        }
    }
</script>

<style scoped>
.kb-menu {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    overflow: hidden;
    height: 100%;
}

.kb-header {
    padding: 16px 24px;
    border-bottom: 1px solid #e5e7eb;
}

.kb-title {
    font-size: 24px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 4px;
}

.kb-subtitle {
    font-size: 14px;
    color: #6b7280;
}

.kb-content-root {
    padding: 8px 0;
}

/* Scrollbar styling */
.kb-menu {
    max-height: 80vh;
    overflow-y: auto;
}

.kb-menu::-webkit-scrollbar {
    width: 6px;
}

.kb-menu::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.kb-menu::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
}

.kb-menu::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
}

/* Mobile styles */
@media (max-width: 960px) {
    .kb-menu {
        border-radius: 0;
        max-width: none;
        max-height: 100vh;
        box-shadow: none;
        height: 100vh;
    }
}
</style>
